var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const API_BASE_URL = window._env_.REACT_APP_SIGNO_API_URL;
export class SageRepository {
    getSageDecryptAsync(encryptedId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${API_BASE_URL}/Sage/Crypto/decrypt_url`;
            const requestBody = JSON.stringify(encryptedId);
            const headers = {
                'Content-Type': 'application/json',
            };
            const response = yield axios.post(url, requestBody, { headers });
            const data = response.data;
            return {
                accessToken: data.accessToken,
                expiration: new Date(data.expiration),
                refreshToken: data.refreshToken,
            };
        });
    }
}
